import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import ArticlePage from "../pages/article/page";
import PricingArticle from "../pages/article/pricing/page";
import BeginnersArticle from "../pages/article/beginners/page";
import ShippingArticle from "../pages/article/shipping/page";
import VsTaobaoArticle from "../pages/article/vs-taobao/page";
import BestProductsArticle from "../pages/article/best-products/page";
import BulkOrdersArticle from "../pages/article/bulk-orders/page";
import QualityArticle from "../pages/article/quality/page";
import PaymentArticle from "../pages/article/payment/page";
import SafetyArticle from "../pages/article/safety/page";
import ShoppingGuide from "../pages/shopping-guide/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/itaobuy-spreadsheet-guide",
    element: <ArticlePage />,
  },
  {
    path: "/itaobuy-spreadsheet-pricing",
    element: <PricingArticle />,
  },
  {
    path: "/itaobuy-spreadsheet-beginners",
    element: <BeginnersArticle />,
  },
  {
    path: "/itaobuy-spreadsheet-shipping",
    element: <ShippingArticle />,
  },
  {
    path: "/itaobuy-spreadsheet-vs-taobao",
    element: <VsTaobaoArticle />,
  },
  {
    path: "/itaobuy-spreadsheet-best-products",
    element: <BestProductsArticle />,
  },
  {
    path: "/itaobuy-spreadsheet-bulk-orders",
    element: <BulkOrdersArticle />,
  },
  {
    path: "/itaobuy-spreadsheet-quality",
    element: <QualityArticle />,
  },
  {
    path: "/itaobuy-spreadsheet-payment",
    element: <PaymentArticle />,
  },
  {
    path: "/itaobuy-spreadsheet-safety",
    element: <SafetyArticle />,
  },
  {
    path: "/shopping-guide",
    element: <ShoppingGuide />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;